import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import API from "../../config/config";
import Routes from "../../config/routes";
import RatingStarts from "../../components/RatingStars/RatingStarts";
import { connect } from "react-redux";
import Link from "next/link";
import { formatPrice } from "../../helpers/utils";
import AffirmPrequalify from "../AffirmPrequalify/AffirmPrequalify";

declare const window: any;
const ProductOverView = ({
  template,
  data,
  rating,
  ratingStatus,
  onToggle,
  setRatingData,
  handleSubmit,
  prodName,
  showLoader,
  hideLoader,
  extendWarrantyId
}: any) => {
  const handleRating = (RatingData: any) => {
    setRatingData(RatingData);
    onToggle();
  };

  // A function for rendering Extend Buttons in product page
  const renderExtendButton = async () => {
    window.Extend.buttons.destroyAll();
    await window.Extend.buttons.render(`#extend-product-${data.id}`, {
      referenceId: `${data.id}`,
    })
  }

  // To render Extend buttons when product data for the page and extend warranty is loaded
  useEffect( () => {
    if(document.getElementById(`extend-product-${data.id}`) !== null && extendWarrantyId !== undefined)
    {
      if(window.Extend)
      {
        showLoader();
        renderExtendButton();
      }
    }
    checkIframeLoaded();    
  },[data,extendWarrantyId]);

  // To check if the iframe has loaded
  const checkIframeLoaded =()=> {
    let iframe = document.querySelector(`#extend-product-${data.id} iframe`) as HTMLIFrameElement;
    if (iframe) {
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDoc.readyState  == 'complete' && iframeDoc.querySelector(".caption")) {
        const style = `
        <style>
          .caption {
            color: white!important;
            width: 100%!important;
            text-align: center!important;
          }
          .button-group {
            max-width: 500px!important;
            margin: auto!important;
          }
          .button {
            color: white!important;
          }
          @media (max-device-width: 480px) {
            .button-group {
              max-width: 325px!important;
              margin: 0!important;
            }
            .caption {
              text-align: left!important;
            }
          }
        </style>
        `;
        iframeDoc.head.innerHTML = iframeDoc.head.innerHTML + style;
        hideLoader();
        return;
      } 
    }
    // If we are here, it is not loaded. Set things up so we check the status again in 100 milliseconds
    window.setTimeout(checkIframeLoaded, 100);
  }

  useEffect(() => {
    if (window.affirm && window.affirm.ui) {
      try {
        window.affirm.ui.refresh();
      } catch (err) {}
    } 
  }, []);

  return (
    data &&
    template && (
      <div className="container-fluid productOverview">
        <Row xs={1} md={2}>
          <Col
            className="product-overview-col"
            xs={{ order: 2 }}
            md={{ order: template.overviewAlignment === "left" ? 1 : 2 }}
          >
            <div style={{ backgroundColor: `${template.backgroundColor}` }}>
              <div className="product-container-left">
                <div
                  className={`product-overview-flex-left ${
                    (data.slug === `cross-body-trainer-pro` ||
                      data.slug === `cross-body-trainer-home`) &&
                    `product-overview-long-title`
                  }`}
                >
                  <div>
                    <img
                      src={
                        data.titleImage ? API.baseUrl + data.titleImage.url : ""
                      }
                      alt={
                        data.titleImage ? data.titleImage.alternativeText : ""
                      }
                    />
                    <div className="product-pro-home">{`${
                      data.slug === `cross-body-trainer-pro`
                        ? `PRO`
                        : data.slug === `cross-body-trainer-home`
                        ? `HOME`
                        : ``
                    }`}</div>
                  </div>
                  <div className="product-overview-price">
                    ${data.price && formatPrice(data.price)}
                  </div>
                  <div className="product-overview-shipping">
                    + Free Shipping
                  </div>
                  <div className="multiple-prod-productdetail-affirm">
                    {data.price > 0 && data.price && (
                      <AffirmPrequalify price={data.price} />
                    )}
                  </div>
                  <div className="productoverview-popstar">
                    <RatingStarts
                      ratingValue={5}
                      className="productoverview-star"
                    />
                    <span
                      onClick={() => {
                        handleRating({
                          reviews: data.product_reviews,
                          id: data.id,
                          title: data.title,
                        });
                      }}
                      className="product-overview-reviews-popup"
                    >
                      Read Reviews
                    </span>
                  </div>
                  <div className="product-overview-belowtext">
                    No Subscription Required
                  </div>
                  {/* In the bottom div extend buttons are going to get rendered */}
                  { prodName !== 'N3 Elite' && 
                    <div className="extend-warranty-product-container">
                      <div id={`extend-product-${data.id}`}></div>
                    </div>
                  }
                  
                  <div>
                    {prodName === `N3 Elite` ? (
                      <Link href={Routes.bundle}>
                        <a>
                          <span className="button-show-now">
                            {template.buttonLabel}
                          </span>
                        </a>
                      </Link>
                    ) : (
                      <Button
                        variant="danger"
                        onClick={handleSubmit}
                        className="button-show-now"
                      >
                        {template.buttonLabel} 
                      </Button>
                    )}
                  </div>
                  <div className="prod-learn-more">
                    <a href="#learn">
                      <span>Learn More</span>
                      <i aria-hidden className="fas fa-caret-down fa-lg" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col
            className="product-overview-col"
            xs={{ order: 1 }}
            md={{ order: template.imageAlignment === "right" ? 2 : 1 }}
          >
            <div
              className="product-overview-right"
              style={{
                backgroundImage: `url(${
                  template.image ? API.baseUrl + template.image.url : ""
                })`,
              }}
            />
          </Col>
        </Row>
      </div>
    )
  );
};

const mapState = (state: any) => {
  return {
    rating: state.rating,
    ratingStatus: state.ratingStatus,
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: "RATING_TOGGLE" }),
    setRatingData: (RatingData: any) => {
      dispatch({ type: "ON_RATING_LOAD", payload: RatingData });
    },
    showLoader: () => dispatch({ type: 'LOADER_SHOW' }),
    hideLoader: () => dispatch({ type: 'LOADER_HIDE' })
  };
};

export default connect(mapState, mapDispatch)(ProductOverView);